import { ReactElement } from "react";
import {
	BusyIndicator
} from "client/Components";
import { GlobalNavigationSidebar } from "client/Features/Layout/GlobalNavigationSidebar/GlobalNavigationSidebar";
import { localize } from "client_legacy/ndaw/culture";
import { AppType } from "client/Api/Apps/common";
import {
	useHandleNavigationInGlobalSubNavigation
} from "client/Features/Layout/GlobalNavigationSidebar/useGlobalNavigationVisibilityState";

export type CalendarSidebarContentFactory = (
	onDateChange: () => void
) => ReactElement | null;

export type CalendarSidebarProps = {
	isLoading: boolean;
	children: CalendarSidebarContentFactory;
};

export const CalendarSidebar = (props: CalendarSidebarProps): ReactElement => {
	const {
		isLoading,
		children
	} = props;

	const handleNavigationInGlobalSubNavigation: () => void = useHandleNavigationInGlobalSubNavigation();

	return (
		<GlobalNavigationSidebar.ActivePanelOverride
			title={localize("_Calendar")}
			kind={AppType.Office365Calendar}
		>
			{isLoading && <BusyIndicator />}
			{children(handleNavigationInGlobalSubNavigation)}
		</GlobalNavigationSidebar.ActivePanelOverride>
	);
};

CalendarSidebar.displayName = "CalendarSidebar";